module.exports = __webpack_public_path__ + "img/icon_map_32_off_100.a413650a.png";